<template>
  <div style="margin-bottom: 100px">
    <div class="ui divider"></div>
    <abstractTable 
      :columns="readingsColumns"
      :data="medicalMachineReadings"
      :classes="'ui celled very compact center aligned table'"
      :keyIsDate="true"
    />
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    medicalMachine: { type: Object, required: true }
  },
  data() {
    return {
      reading: null
    }
  },
  computed: {
    readingsColumns () {
      return [
        { header: 'Shift Date', fieldName: 'date', show: true, width: '30%' },
        { header: 'First reading', fieldName: 'firstReading', show: true },
        { header: 'Last reading', fieldName: 'lastReading', show: true }
      ]
    },
    medicalMachineReadings () {
      const medicalMachineReadingsGroupedShiftId = window._.groupBy(this.medicalMachine.medical_machine_readings, 'room_shift_id') 
      const formattedData = []
      for (const [room_shift_id, readings] of Object.entries(medicalMachineReadingsGroupedShiftId)) {
        formattedData.push({
          date: window.moment(readings[0].room_shift.started_at).format('DD/MM/YYYY - hh:mm A'),
          firstReading: readings[0].reading,
          lastReading:  readings[1] ? readings[1].reading : '-'
        })
      }

      return formattedData;
    }
  },
  methods: {
    submit() {
      if (this.reading) {
        this.$http.post(`medical_machines/${this.medicalMachine.id}/add/reading`, {
          reading: this.reading,
          clinic_id: this.getClinicId()
        }).then(response => {
          this.medicalMachine.medical_machine_readings.push(response.data)
          this.reading = null
        })
      }
    }
  },
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/medical_machines/medical_machine_components/details_components/Readings.vue